import { BBadge } from './badge';
import { pluginFactory } from '../../utils/plugins';
var BadgePlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BBadge: BBadge
  }
});
export { BadgePlugin, BBadge };


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/esm/components/badge/index.js
// module id = 260
// module chunks = 0 1 2 3 4 5 6 7